export const getInitials = ({ username, first_name, last_name }) => {
  let parts = [username];
  if (first_name) {
    parts = [first_name];
    if (last_name) parts.push(last_name);
  }

  let initials = '';
  for (let i = 0; i < parts.length; i += 1) {
    if (parts[i]?.length > 0 && parts[i] !== '') {
      initials += parts[i][0];
    } else initials += 'u';
  }
  return initials?.toUpperCase();
};
